module.exports = __webpack_public_path__ + "img/user8.e16cc55a.jpg";